import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import AppBanner from "../components/AppBanner";
import Header from "../components/Header";
import EmotionList from "../components/EmotionList";
import "../styles/Home.css";
import peopleImage from "../assets/group.png";
import centerCircles from "../assets/center-circles.png";
import Faq from "../components/Faq";
import ServiceTabs from "../components/ServiceTabs";
import { GetUserByIdApi } from "../services/Api";
import appStore from "../assets/PopUp/app-store.png";
import playStore from "../assets/PopUp/play-store.png";

const HomePage = () => {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(true);

  const handleStartSpeakingClick = async () => {
    const response = await GetUserByIdApi();
    if (response) {
      if (response.audioTalkTime < 300) {
        const userChoice = window.confirm(
          `Your audio talk time is less than 5 min: ${response.audioTalkTime}. Please Recharge!`
        );

        if (userChoice) {
          navigate("/prime");
          return;
        }
      }
      navigate("/talk");
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setShowBanner(true);
    }, 10 * 60 * 1000); // 10 minutes

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="page-container relative">
      {/* App Banner */}
      {showBanner && <AppBanner onClose={() => setShowBanner(false)} />}

      {/* Header */}
      <Header />

      {/* Emotion List */}
      <div className="emotion-wrapper">
        <EmotionList />
      </div>

      {/* Info Banner */}
      <div className="info-banner-wrapper">
        <div className="info-banner">
          <div className="info-left">
            <h2 className="info-heading">1000+ Psychologists</h2>
            <p className="info-subheading">Ready to be at your Doorstep!</p>
            <button className="speak-button" onClick={() => navigate("/prime")}>
              Speak with psychologist
            </button>
          </div>
          <div className="info-image">
            <img src={peopleImage} alt="People talking" />
          </div>
        </div>

        <div
          className="relative flex items-center justify-center w-[200px] h-[200px] mx-auto mt-8 cursor-pointer"
          onClick={handleStartSpeakingClick}
        >
          {/* Continuous Wave Ripples */}
          <span className="absolute w-[200px] h-[200px] rounded-full bg-cyan-400 opacity-30 animate-[ripple_2.4s_ease-out_0s_infinite]"></span>
          <span className="absolute w-[200px] h-[200px] rounded-full bg-cyan-400 opacity-30 animate-[ripple_2.4s_ease-out_0.8s_infinite]"></span>
          <span className="absolute w-[200px] h-[200px] rounded-full bg-cyan-400 opacity-30 animate-[ripple_2.4s_ease-out_1.6s_infinite]"></span>

          {/* Center Image */}
          <img
            src={centerCircles}
            alt="Concentric Circles"
            className="relative z-10 w-[200px] h-[200px]"
          />
        </div>
      </div>

      {/* GoodCall Plan Section */}
      <div className="goodcall-plan-text">
        <h2 className="plan-title">Plans & Pricing</h2>
        <p>
          Welcome to Goodpeople—where care meets clarity, and connection becomes
          healing. This isn’t just a platform. It’s a movement to bring back
          what the world has quietly lost: real human support.
        </p>
        <p>
          Whether it’s an honest conversation through Good Call, emotional
          protection with the World Counseling Card, or building a mentally
          resilient workforce through Employee Care, everything we create is
          rooted in one belief— people deserve better care, not just better
          technology.
        </p>
        <p>
          At Goodpeople, we don't wait for breakdowns. We build breakthroughs.{" "}
          <br />
          This is not just where help begins. <br />
          This is where humanity comes back home.
        </p>
      </div>

      {/* Service Tabs & FAQ */}
      <ServiceTabs />
      <Faq />

      {/* Sticky Rotated Store Buttons - Right Side */}
      <div
        className="fixed top-1/2 right-[-80px]
 transform -translate-y-1/2 z-50 flex flex-col items-center gap-48"
      >
        {/* App Store Button */}
        {/* <div>
          <a
            href="https://apps.apple.com/us/app/goodpeople-call/id6740238582"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={appStore}
              alt="App Store"
              className="h-24 transform rotate-[270deg] origin-center hover:scale-110 transition-transform"
            />
          </a>
        </div> */}

        {/* Play Store Button */}
        {/* <div>
          <a
            href="https://play.google.com/store/apps/details?id=com.emotalk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={playStore}
              alt="Google Play"
              className="h-24 transform rotate-[270deg] origin-center hover:scale-110 transition-transform"
            />
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default HomePage;
